import React, { Component, Fragment } from 'react'
import Routes from './routes'
import Message from './components/Message'
import Confirm from './components/Confirm'
import { withRouter } from 'react-router-dom'
import { searchTableActions } from './actions'
import { connect } from 'react-redux'

class App extends Component {
  componentDidMount() {
    this.historyListener = this.props.history.listen((newHistory, action) => {
      if ((newHistory.state || {}).term) return
      if (newHistory.pathname !== this.props.location.pathname) {
        this.props.clearSearch()
      }
    })
  }

  render() {
    return (
      <Fragment>
        <Message />
        <Confirm />
        <Routes />
      </Fragment>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    clearSearch: () => {
      dispatch(searchTableActions.clearTerm())
    }
  }
}

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(App)
)



// WEBPACK FOOTER //
// ./src/App.js